import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TopNav from './TopNav';
import Footer from './Footer';

const PhotographyPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const photos = [
    {
      id: 1,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/ay7a2w23_penns-landing-i95-overpass.jpg',
      alt: 'Penns Landing I95 Overpass'
    },
    {
      id: 2,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/evq3z3kd_penns-landing-stairs.jpg',
      alt: 'Penns Landing Stairs'
    },
    {
      id: 3,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/a2rjnw6p_delaware-river-new-jersey.jpg',
      alt: 'Delaware River New Jersey'
    },
    {
      id: 4,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/78e9jwiy_psi-performance-ferrari-gtr.jpg',
      alt: 'PSI PROFORMANCE Ferrari GTR'
    },
    {
      id: 5,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/td3llkdd_penns-landing-restrooms.jpg',
      alt: 'Penns Landing Restrooms'
    },
    {
      id: 6,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/2t9go4nc_penns-landing-constantine.jpg',
      alt: 'Penns Landing Constantine'
    },
    {
      id: 7,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/yspoo3rb_carlos-tires-porsche-rx7.jpg',
      alt: 'Carlos Tires Porsche RX7'
    },
    {
      id: 8,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/hau3lhj2_philadelphia-art-museum-plate.jpg',
      alt: 'Philadelphia Art Museum Plate'
    },
    {
      id: 9,
      src: 'https://customer-assets.emergentagent.com/job_dev-portfolio-997/artifacts/bz9ofw5g_philadelphia-art-museum-stained-glass.jpg',
      alt: 'Philadelphia Art Museum Stained Glass'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="photography-page">
      <TopNav />
      <div className="photography-container">
        <Link to="/media" className="back-link">← Back to Media</Link>
        
        <h1 className="page-title">Photography</h1>
        <p className="page-subtitle">Captured moments and perspectives</p>
        
        <div className="carousel-container">
          <button className="carousel-btn prev-btn" onClick={prevSlide}>
            ‹
          </button>
          
          <div className="carousel-wrapper">
            <div 
              className="carousel-track"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {photos.map((photo) => (
                <div key={photo.id} className="carousel-slide">
                  <img 
                    src={photo.src} 
                    alt={photo.alt}
                    className="carousel-image"
                  />
                </div>
              ))}
            </div>
          </div>
          
          <button className="carousel-btn next-btn" onClick={nextSlide}>
            ›
          </button>
        </div>

        <div className="carousel-dots">
          {photos.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>

        <p className="photo-caption">{photos[currentIndex].alt}</p>
        
        <Footer />
      </div>

      <style jsx>{`
        .photography-page {
          min-height: 100vh;
          background: #151312;
          padding: 40px 20px;
        }

        .photography-container {
          max-width: 1000px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .back-link {
          align-self: flex-start;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: #f46c38;
          text-decoration: none;
          margin-bottom: 40px;
          transition: opacity 0.2s ease;
        }

        .back-link:hover {
          opacity: 0.8;
        }

        .page-title {
          font-family: 'Poppins', sans-serif;
          font-size: 48px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 12px;
          text-align: center;
        }

        .page-subtitle {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          color: #998f8f;
          margin-bottom: 40px;
          text-align: center;
        }

        .carousel-container {
          width: 100%;
          max-width: 800px;
          display: flex;
          align-items: center;
          gap: 16px;
          position: relative;
        }

        .carousel-wrapper {
          flex: 1;
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        }

        .carousel-track {
          display: flex;
          transition: transform 0.5s ease;
        }

        .carousel-slide {
          min-width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .carousel-image {
          width: 100%;
          height: auto;
          max-height: 600px;
          object-fit: contain;
          display: block;
        }

        .carousel-btn {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(182, 180, 189, 0.1);
          border: 1px solid rgba(182, 180, 189, 0.2);
          color: #ffffff;
          font-size: 28px;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .carousel-btn:hover {
          background: rgba(244, 108, 56, 0.2);
          border-color: #f46c38;
        }

        .carousel-dots {
          display: flex;
          gap: 10px;
          margin-top: 24px;
        }

        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(182, 180, 189, 0.3);
          border: none;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .dot:hover {
          background: rgba(182, 180, 189, 0.5);
        }

        .dot.active {
          background: #f46c38;
          transform: scale(1.2);
        }

        .photo-caption {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: #998f8f;
          margin-top: 16px;
          text-align: center;
        }

        @media (max-width: 768px) {
          .photography-page {
            padding: 20px 16px;
          }

          .page-title {
            font-size: 32px;
          }

          .page-subtitle {
            font-size: 14px;
            margin-bottom: 24px;
          }

          .back-link {
            margin-bottom: 24px;
          }

          .carousel-container {
            gap: 8px;
          }

          .carousel-btn {
            width: 36px;
            height: 36px;
            font-size: 22px;
          }

          .carousel-image {
            max-height: 400px;
          }

          .carousel-dots {
            gap: 8px;
          }

          .dot {
            width: 10px;
            height: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default PhotographyPage;
